import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    autofocus: { type: Boolean, default: false }
  }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      plugins: ['remove_button']
    })

    if (this.autofocusValue) {
      this.modalElement = this.element.closest('.modal');
      if (this.modalElement) {
        this.boundFocusTomSelect = this.focusTomSelect.bind(this);
        this.modalElement.addEventListener('shown.bs.modal', this.boundFocusTomSelect);
      }
    }
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
    if (this.modalElement && this.boundFocusTomSelect) {
      this.modalElement.removeEventListener('shown.bs.modal', this.boundFocusTomSelect);
    }
  }

  focusTomSelect() {
    if (this.tomSelect) {
      this.tomSelect.focus();
    }
  }
}
